import { colors, Container, Grid, Paper, TextField, Typography } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useStylesAcc } from "./CheckBoxComponent";
import { useTranslation } from "react-i18next";
export default function UserForm(props) {
  const { users, gData, setGData } = props;
  const { t } = useTranslation(["forms"]);
  //   const [gData, setGData] = useSharedData();
  const classes = useStylesAcc();

  return (
    <Container
      style={{
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        listStyle: "none",
        padding: "10px",
        margin: "0px",
        backgroundColor: colors.grey[50],
      }}
      component={Paper}
    >
      {gData.id == 1 ? (
        <Grid item lg={8} md={8} sm={7} xs={6}>
          <Typography className={classes.heading2}>{t("sales-settings")}</Typography>

        </Grid>
      ):gData.id == 2?(
        <Grid item lg={8} md={8} sm={7} xs={6}>
        <Typography className={classes.heading2}>{t("pos-settings")}</Typography>

      </Grid>
      ):
        gData.id == 3?(
          <Grid item lg={8} md={8} sm={7} xs={6}>
          <Typography className={classes.heading2}>{t("purchase-settings")}</Typography>
  
        </Grid>
      ):gData.id == 4?(
        <Grid item lg={8} md={8} sm={7} xs={6}>
        <Typography className={classes.heading2}>{t("basic-data-settings")}</Typography>

      </Grid>):gData.id == 5?(
        <Grid item lg={8} md={8} sm={7} xs={6}>
        <Typography className={classes.heading2}>{t("quotation-settings")}</Typography>

      </Grid>):gData.id == 6?(
        <Grid item lg={8} md={8} sm={7} xs={6}>
        <Typography className={classes.heading2}>{t("purchase-order-settings")}</Typography>

      </Grid>):
      (
        <Grid item lg={8} md={8} sm={7} xs={6}>
        <Typography className={classes.heading2}>{t("warehouse-settings")}</Typography>

      </Grid>)}

      <Grid item lg={3} md={3} sm={4} xs={6}>
        <Autocomplete
          value={gData.user}
          onChange={(event, newValue) => {
            // onChangeAutoData("user", newValue);
            setGData({ ...gData, user: newValue });
          }}
          id="combo-box-demo"
          size="small"
          options={users}
          //getOptionLabel={(option) => option.name}
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.username
          }
          style={{}}
          disableClearable
          renderInput={(params) => (
            <TextField
              {...params}
              InputLabelProps={{ shrink: true }}
              label={t("user")}
              variant="outlined"
            />
          )}
        />
      </Grid>
    </Container>
  );
}
